export default __webpack_public_path__ + "static/betstop-b486516004ff6e34875517f2d9968692.png";